import React, { useEffect, useState } from "react";
import {
    fetchDataSourcesAdmin,
    createDataSource,
    updateDataSource,
    deleteDataSource,
    extractErrorMessage,
} from "../../services/adminApi";

const emptyDraft = { name: "", url: "" };

const DataSourcesEditor = () => {
    const [sources, setSources] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [busyId, setBusyId] = useState(null);
    const [newDraft, setNewDraft] = useState(emptyDraft);
    const [creating, setCreating] = useState(false);

    const load = () => {
        setLoading(true);
        fetchDataSourcesAdmin()
            .then(setSources)
            .catch((err) =>
                setError(extractErrorMessage(err, "Не удалось загрузить список"))
            )
            .finally(() => setLoading(false));
    };

    useEffect(load, []);

    const patchLocal = (id, fields) => {
        setSources((prev) =>
            prev.map((s) => (s.id === id ? { ...s, ...fields } : s))
        );
    };

    const handleSaveRow = async (source) => {
        setBusyId(source.id);
        setError("");
        try {
            const saved = await updateDataSource(
                source.id,
                source.name,
                source.url
            );
            setSources((prev) =>
                prev.map((s) => (s.id === source.id ? saved : s))
            );
        } catch (err) {
            setError(extractErrorMessage(err, "Не удалось сохранить"));
        } finally {
            setBusyId(null);
        }
    };

    const handleDelete = async (id) => {
        setBusyId(id);
        setError("");
        try {
            await deleteDataSource(id);
            setSources((prev) => prev.filter((s) => s.id !== id));
        } catch (err) {
            setError(extractErrorMessage(err, "Не удалось удалить"));
        } finally {
            setBusyId(null);
        }
    };

    const handleCreate = async (e) => {
        e.preventDefault();
        if (!newDraft.name.trim() || !newDraft.url.trim()) return;
        setCreating(true);
        setError("");
        try {
            const created = await createDataSource(
                newDraft.name.trim(),
                newDraft.url.trim()
            );
            setSources((prev) => [...prev, created]);
            setNewDraft(emptyDraft);
        } catch (err) {
            setError(extractErrorMessage(err, "Не удалось добавить"));
        } finally {
            setCreating(false);
        }
    };

    if (loading) return <p>Загрузка…</p>;

    return (
        <div className="admin-section">
            <h2 className="admin-section-title">Данные — наборы</h2>
            <p className="admin-hint">
                Список источников, который виден на публичной вкладке
                «Данные». Название может быть как коротким («НГУ»), так и
                полной библиографической ссылкой.
            </p>

            {error && <p className="admin-error">{error}</p>}

            {sources.map((source) => (
                <div className="admin-repeatable-item" key={source.id}>
                    <label className="admin-field">
                        <span>Название</span>
                        <textarea
                            rows={2}
                            value={source.name}
                            onChange={(e) =>
                                patchLocal(source.id, { name: e.target.value })
                            }
                        />
                    </label>
                    <label className="admin-field">
                        <span>Ссылка</span>
                        <input
                            type="text"
                            value={source.url}
                            onChange={(e) =>
                                patchLocal(source.id, { url: e.target.value })
                            }
                        />
                    </label>
                    <div className="admin-row-actions">
                        <button
                            type="button"
                            className="admin-primary-button"
                            disabled={busyId === source.id}
                            onClick={() => handleSaveRow(source)}
                        >
                            Сохранить
                        </button>
                        <button
                            type="button"
                            className="admin-remove-button"
                            disabled={busyId === source.id}
                            onClick={() => handleDelete(source.id)}
                        >
                            Удалить
                        </button>
                    </div>
                </div>
            ))}

            <form className="admin-repeatable-item" onSubmit={handleCreate}>
                <h3 className="admin-subsection-title">Новый источник</h3>
                <label className="admin-field">
                    <span>Название</span>
                    <textarea
                        rows={2}
                        value={newDraft.name}
                        onChange={(e) =>
                            setNewDraft((d) => ({ ...d, name: e.target.value }))
                        }
                        placeholder="Например: НГУ"
                    />
                </label>
                <label className="admin-field">
                    <span>Ссылка</span>
                    <input
                        type="text"
                        value={newDraft.url}
                        onChange={(e) =>
                            setNewDraft((d) => ({ ...d, url: e.target.value }))
                        }
                        placeholder="https://..."
                    />
                </label>
                <button
                    type="submit"
                    className="admin-add-button"
                    disabled={creating}
                >
                    {creating ? "Добавляем…" : "+ Добавить источник"}
                </button>
            </form>
        </div>
    );
};

export default DataSourcesEditor;
